import { Component, OnInit, ViewChild } from '@angular/core';
import {
  DetailSearchConfiguration,
  OmniApi,
  SearchParameters,
  SearchRequest,
  Session,
} from 'src/app/my-sedgwick';
import {
  BaseComponent,
  ListComponent,
  LoadingState,
  SnackbarService,
} from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { UserActions } from 'src/app/shared/models/user';

@Component({
    selector: 'app-return-to-work-list-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        title="Returning to Work"
        [headerLevel]="1"
        class="tw-w-full"
        [canExpand]="false"
        >
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="search($event)"
            (clear)="clear()"
            [loading]="loading"
            [translationRequest]="translationRequest"
            >
            <ng-template #AccommodationMsg>
              @if (showMsg) {
                <div class="app-pt1">
                  <app-toast type="Info" [message]="'If an accommodation has a related leave claim, then the returning to work item will appear with the leave claim. If you don\\'t find what you are looking for, please refine your search.'">
                  </app-toast>
                </div>
              }
            </ng-template>
            <ng-template #results>
              <app-search-count-row
                [count]="returnToWorks.length"
                resultSingle="item"
                resultPlural="items"
                [isInDirectInclude]="isInDirectReporting"
                [isSupervisor]="isSupervisorSelect"
                [supervisorFullName]="SupervisorFullName"
              ></app-search-count-row>
              <app-return-to-work
                [returnToWork]="returnToWorks"
                [translationRequest]="translationRequest"
                class="tw-w-full"
                (export)="searchForm.appendExport($event)"
                />
              </ng-template>
            </app-detail-search-form>
          </div>
        </app-panel>
      </app-section>
    `,
    styles: ``,
    standalone: false
})
export class ReturnToWorkListPageComponent extends BaseComponent implements OnInit  {
  userAction = UserActions.ViewOwnMgrDb;
  config = new DetailSearchConfiguration();

  returnToWorks: any[];
  showMsg: boolean = false;

  isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = true;
  

  loading: LoadingState;
  
  translationRequest = new TranslationRequest({
          language: sessionStorage.getItem('languagepreference'),
          key: null,
          contNum: 0,
          tableName: null,
          primaryKey: null,
          primaryValue: null,
          lob: null,
          group: 'ReturnToWork',
          subGroup: 'ReturnToWork',
        });

  @ViewChild('searchForm', { static: false }) searchForm: ListComponent;

  constructor(private omniApi: OmniApi, private snackbar: SnackbarService,private session : Session) {
    super();
    this.config.key = 'omni-dashboard:return-to-work';
    this.config.ssn.visible = false;
    this.config.supervisor.visible = false;
    this.config.includeIndirect.visible = false;
    this.config.employeeId.widthPercent = 25;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.startDate.visible = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.payType.visible = false;
  }
  ngOnInit(): void {
    
    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = this.verifyIndirectReport();
    }
  }

  verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession == 'true';
    }


  }
  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    this.loading = 'Loading';
    const searchParam  = request.getParameters();
   
    if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      searchParam.supervisor = supervisor;
      searchParam.managerEmpUnum = supervisor.empUnum;
    }
    else{
      searchParam.supervisor = null;
      searchParam.managerEmpUnum = null;
    }

     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      searchParam.includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
    else {
      searchParam.includeIndirectReports = false;
    }
     
    
    this.returnToWorks = await this.omniApi.getRtws(searchParam);
    this.loading = this.returnToWorks.length > 0 ? 'Loaded' : 'Empty';
    if (this.searchForm.formGroup.value.lob?.includes('AD')) {
      //this.snackbar.show(
      //  "If an accommodation has a related leave claim, then the returning to work item will appear with the leave claim. If you don't find what you are looking for, please refine your search.",
      //  SnackbarType.Info
      //);
      this.showMsg = true;

    } else {
      this.showMsg = false;
    }
    this.config.initialSearch = false;
  }
  async clear() {
    this.showMsg = false;
  }
}
